import { useTokens } from '../../tokens';
import { PSection, usePresetBuilder } from '../context.jsx';
import { ColDisplay, ColKey } from './ColumnSelector.jsx';

/**
 * SortPicker — par select + botão. Select lista TODAS as colunas do preset
 * (exceto 'select' que é fixa); botão alterna asc/desc e fica desabilitado
 * quando nenhuma coluna escolhida.
 */
function SortPicker({ cols, sort, onChange, customColumnsById }) {
    const T = useTokens();
    const selectableCols = cols.filter((c) => ColKey(c) !== 'select');
    const currentCol = sort?.col || '';
    const currentDir = sort?.dir || 'desc';

    return (
        <div style={{ display: 'flex', gap: 6 }}>
            <select
                value={currentCol}
                onChange={(e) => onChange(e.target.value ? { col: e.target.value, dir: currentDir } : null)}
                style={{
                    flex: 1,
                    padding: '5px 8px',
                    borderRadius: 4,
                    border: `1px solid ${T.line}`,
                    background: T.bg,
                    color: T.ink,
                    fontSize: 12,
                    outline: 'none',
                }}
            >
                <option value="">— sem ordenação —</option>
                {selectableCols.map((c) => {
                    const key = ColKey(c);
                    return (
                        <option key={key} value={key}>
                            {ColDisplay(c, customColumnsById)}
                        </option>
                    );
                })}
            </select>
            <button
                type="button"
                onClick={() => currentCol && onChange({ col: currentCol, dir: currentDir === 'desc' ? 'asc' : 'desc' })}
                disabled={!currentCol}
                title="Clique pra alternar"
                style={{
                    padding: '5px 10px',
                    borderRadius: 4,
                    border: `1px solid ${T.line}`,
                    background: T.bg,
                    color: T.ink,
                    fontSize: 12,
                    cursor: currentCol ? 'pointer' : 'not-allowed',
                    opacity: currentCol ? 1 : 0.4,
                    outline: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                    whiteSpace: 'nowrap',
                }}
            >
                <span style={{ fontFamily: T.mono }}>{currentDir === 'desc' ? '↓' : '↑'}</span>
                <span>{currentDir === 'desc' ? 'Decrescente' : 'Crescente'}</span>
            </button>
        </div>
    );
}

/**
 * SortConfig section — Ordenação padrão. Consome o context pra pegar
 * cols/sort/customColumnsById; helpers colKey/colDisplay vêm do ColumnSelector
 * (única source pra normalização de nome/key de coluna).
 */
export function SortConfig() {
    const { draft, patch, customColumnsById } = usePresetBuilder();
    const cols = Array.isArray(draft?.columns) ? draft.columns : [];

    return (
        <PSection title="Ordenação padrão">
            <SortPicker
                cols={cols}
                sort={draft?.sort || null}
                onChange={(nextSort) => patch({ sort: nextSort || undefined })}
                customColumnsById={customColumnsById}
            />
        </PSection>
    );
}
